// extracted by mini-css-extract-plugin
module.exports = {"checkboxes":"style_checkboxes___lMag","checkbox":"style_checkbox__3JuVE","empty":"style_empty__eyGCS"};